<template>
  <!-- prettier-ignore -->
  <div
    v-if="isBeforeLivestreamStarts"
    class="bandana-v7-teaser position-relative"
    style="background: repeat center center url('https://img.fortawesome.com/1ce05b4b/tablecloth-pattern3.png'), linear-gradient(135deg, var(--fa-yellow), var(--fa-dk-yellow)); box-shadow: 0 0 5px 5px var(--fa-dk-gravy-transparent2) inset; overflow: hidden;"
  >
    <div class="container">
      <div class="row roomy">
        <div
          v-if="hasBeenCollapsed"
          class="column-12 padding-y-xl padding-x-0 margin-left-xl tablet:margin-left-0"
        >
          <div class="text-center">
            <h2 class="h4 margin-top-0 margin-bottom-3xs">We're changing the recipe...</h2>
            <p class="padding-right-2xl tablet:padding-right-0">
              Join us for a special livestream event on
              <a
                href="/files/Font-Awesome-Special-Announcement.ics"
                download
                aria-label="Download calendar invite!"
                data-balloon-pos="up"
                style="--link-color: var(--fa-navy); --link-hover-color: var(--fa-dk-blue)"
              >
                <strong
                  ><time :datetime="`${endtime}`">{{ formatDate(endtime) }}</time></strong
                >
              </a>
              <a
                target="_blank"
                href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=Font+Awesome+Special+Announcement&dates=20250402T170000Z/20250402T173000Z&details=Join+us+for+a+special+announcement+on+fontawesome.com%21&location=https%3A%2F%2Ffontawesome.com"
                style="--link-color: var(--fa-navy); --link-hover-color: var(--fa-dk-blue)"
                aria-label="Add to Google calendar!"
                data-balloon-pos="up"
              >
                <font-awesome-icon :icon="$v6.solid.faArrowUpRightFromSquare" class="margin-x-4xs" />
              </a>
              and see what we've got cooking!
            </p>
          </div>
        </div>
        <div
          v-else
          class="column-12 text-center padding-y-8xl tablet:padding-y-4xl position-relative"
        >
          <div class="pancakes position-absolute z-1">
            <img
              src="https://img.fortawesome.com/1ce05b4b/pancakes2.png"
              alt="illustration of pancakes"
            />
          </div>
          <div class="coffee position-absolute z-1">
            <img
              src="https://img.fortawesome.com/1ce05b4b/coffee2.png"
              alt="illustration of coffee in a diner mug"
            />
          </div>
          <div class="menu position-absolute z-1">
            <img
              src="https://img.fortawesome.com/1ce05b4b/menu2.png"
              alt="illustration of a diner menu that says Serving Fresh Icons Since 2012"
            />
          </div>
          <div class="position-relative z-2">
            <font-awesome-icon
              :icon="$v6.brands.faFontAwesome"
              size="3x"
            />
            <h2 class="h3 margin-top-xl margin-bottom-md">We're changing the recipe...</h2>
            <p style="--paragraph-margin-bottom: var(--spacing-xl); line-height: 1.5">
              Join us for a special livestream event on<br />
              <a
                href="/files/Font-Awesome-Special-Announcement.ics"
                download
                aria-label="Download calendar invite!"
                data-balloon-pos="up"
                style="--link-color: var(--fa-navy); --link-hover-color: var(--fa-dk-blue)"
              >
                <strong
                  ><time :datetime="`${endtime}`">{{ formatDate(endtime) }}</time></strong
                >
              </a>
              <a
                target="_blank"
                href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=Font+Awesome+Special+Announcement&dates=20250402T170000Z/20250402T173000Z&details=Join+us+for+a+special+announcement+on+fontawesome.com%21&location=https%3A%2F%2Ffontawesome.com"
                style="--link-color: var(--fa-navy); --link-hover-color: var(--fa-dk-blue)"
                aria-label="Add to Google calendar"
                data-balloon-pos="up"
              >
                <font-awesome-icon :icon="$v6.solid.faArrowUpRightFromSquare" class="margin-left-2xs" />
              </a>
              <br />and see what we've got cooking!
            </p>
            <div
              class="countdown display-flex align-center"
              style="
                gap: var(--spacing-sm);
                --card-margin-bottom: var(--spacing-xs);
                --border-color: var(--fa-dk-yellow);
                --card-vertical-padding: var(--spacing-md);
                --card-horizontal-padding: var(--spacing-lg);
                --tag-background: transparent;
                --tag-padding: 0;
              "
            >
              <div class="display-flex flex-column">
                <span
                  class="card with-border"
                  style="min-width: var(--spacing-5xl)"
                  ><strong style="font-size: var(--font-size-lg)">{{ days }}</strong></span
                >
                <span class="tag">{{ formatPlural(days, 'day') }}</span>
              </div>
              <div class="display-flex flex-column">
                <span
                  class="card with-border"
                  style="min-width: var(--spacing-5xl)"
                  ><strong style="font-size: var(--font-size-lg)">{{ hours }}</strong></span
                >
                <span class="tag">{{ formatPlural(hours, 'hour') }}</span>
              </div>
              <div class="display-flex flex-column">
                <span
                  class="card with-border"
                  style="min-width: var(--spacing-5xl)"
                  ><strong style="font-size: var(--font-size-lg)">{{ minutes }}</strong></span
                >
                <span class="tag">{{ formatPlural(minutes, 'minute') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="position-absolute top-md"
          style="right: var(--spacing-3xl)"
        >
          <button
            class="close margin-top-0 flat link"
            style="--link-color: var(--fa-navy); --button-padding: var(--spacing-sm)"
            :aria-label="toggleBandanaLabel"
            data-balloon-pos="left"
            @click="toggleBandana"
          >
            <font-awesome-icon
              :icon="$v6.solid.faAngleDown"
              :class="[{ 'fa-rotate-180': !hasBeenCollapsed }]"
              size="lg"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import pluralize from 'pluralize'
  import { preSaleStart, timeToPreSaleEnd } from 'app/views/timerUtils'

  const hasBeenCollapsedKey = function (bandanaName) {
    return `Bandana Dismissed - ${bandanaName}`
  }

  export default {
    name: 'Bandana',

    props: {
      bandanaName: {
        type: String,
        default: null,
        required: true
      }
    },

    data() {
      const hasBeenCollapsed = localStorage.getItem(hasBeenCollapsedKey(this.bandanaName))

      return {
        hasBeenCollapsed: hasBeenCollapsed === '1' ? true : false,
        endtime: preSaleStart,
        days: 0,
        hours: 0,
        minutes: 0
      }
    },

    computed: {
      isBeforeLivestreamStarts() {
        return this.minutes > 0
      },

      daysLeft() {
        return timeToPreSaleEnd().days
      },

      toggleBandanaLabel() {
        if (this.hasBeenCollapsed) {
          return 'Show More'
        } else {
          return 'Got it! Collapse this!'
        }
      }
    },

    methods: {
      expandBandana() {
        localStorage.setItem(hasBeenCollapsedKey(this.bandanaName), 0)
        this.$posthog.capture('bandana:show_button_click')
        this.hasBeenCollapsed = false
      },
      collapseBandana() {
        localStorage.setItem(hasBeenCollapsedKey(this.bandanaName), 1)
        this.$posthog.capture('bandana:collapse_button_click')
        this.hasBeenCollapsed = true
      },

      toggleBandana() {
        if (this.hasBeenCollapsed) {
          this.expandBandana()
        } else {
          this.collapseBandana()
        }
      },

      formatDate(date) {
        return `${date.toFormat('MMMM d, yyyy')} 1pm ET (10am PT)`
      },

      formatPlural(number, word) {
        return pluralize(word, number)
      }
    }
  }
</script>
